











import {Component, Vue} from "vue-property-decorator";
import AppDialogContainer from "@/components/AppDialogContainer.vue";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import CookieBanner from "@/components/CookieBanner.vue";
import ScreensaverManager from "@/components/ScreensaverManager.vue";

@Component({
  components: {
    AppDialogContainer,
    CookieBanner,
    ScreensaverManager,
  }
})
export default class App extends Vue {
  isInit = false;
  iosFullscreen = false;
  scrollY: number = 0;
  cookieBannerData = null;

  created() {
    bus.$on(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);
  }

  beforeMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const kiosk = urlParams.get('kiosk');
    if (kiosk === 'true') {
      this.$store.commit('rhizome/setPropertyInState', { name: 'kioskMode', value: true });
      document.body.classList.add('kiosk');
    }
  }

  async mounted() {
    const response: any = await this.$store.dispatch('contentPage/getEndpoints');
    this.cookieBannerData = response.cookie_banner;
    this.isInit = true;
    window.addEventListener('resize', this.calcVh);
    this.calcVh();
  }

  get withLayout(): boolean {
    let hideOnRoutes = [
      RouterStore.ROUTE_NAME.RHIZOME_PAGE,
    ];
    return !hideOnRoutes.includes(this.$store.state.route.name);
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  calcVh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  iosFullscreenChange(state) {
    this.scrollY = window.scrollY || window.pageYOffset || +localStorage.getItem('positionY');
    localStorage.setItem('positionY', this.scrollY.toString());
    if (state) {
      this.scrollY = window.scrollY;
    }
    else {
      setTimeout( () => {
        window.scrollTo({
          top: +localStorage.getItem('positionY'),
          behavior: 'instant',
        } as any);
        localStorage.removeItem('positionY');
      });
    }
    this.iosFullscreen = state;
  }

  destroyed() {
    window.removeEventListener('resize', this.calcVh);
    bus.$off(EventEmitter.Events.IOS_FULLSCREEN_CHANGE, this.iosFullscreenChange);
  }
}
